import { SvgIconType } from './svg.interface';

const Clock: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM8.32356 6.47548L6.75 5.56699V3C6.75 2.58579 6.41421 2.25 6 2.25C5.58579 2.25 5.25 2.58579 5.25 3V6C5.25 6.28272 5.40643 6.52891 5.63747 6.65672L7.57356 7.77452C7.93228 7.98163 8.39097 7.85872 8.59808 7.5C8.80518 7.14128 8.68228 6.68259 8.32356 6.47548Z"
      fill={color}
    />
  </svg>
);

export default Clock;
